export const PrivateMobileFourth = () => {
    return <div>
        <div className="px-[8px] flex gap-[20px]">
            <div className="min-w-[100px] flex flex-col items-center ">
                <div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">私有化部署</div>
                <div className="mt-[15px] w-[82px] h-[28px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[4px] flex items-center justify-center ">
                    <a
                        href="https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b"
                        target="_blank"
                    >
                        <div className=" font-normal text-[12px] text-[#FFFFFF]">
                            联系部署
                        </div>
                    </a>
                </div>
            </div>
            <div className="text-[12px] font-light text-[rgba(51,51,51,1)]">在光年K-WAN的私有化部署版本中，针对每个企业在使用时的不同需求，光年K-WAN提供了功能定制服务，满足各企业的个性化需求，为企业提供丰富的功能选择。除了功能定制之外，面对对自有系统集成有较高要求的企业，光年K-WAN支持企业内部系统深度集成，同时还支持与内部系统打通，将新一代的在线产研协作方案与企业自身的协同办公体系深度结合，兼顾软件性能与企业成员管理。
            </div>
        </div>

        <img src="/imgs/private/20.png" className="mt-[10px]" />
    </div>
}